<template>
  <div class="waitingcall">
    <router-view
      :ln="ln"
      :locale="locale"
      :isPublic="isPublic"
      :translateType="translateType"
      :info="info"
      :spaceCodeName="spaceCodeName"
      :activate="activate"
      :availableTime="availableTime"
      @refresh="init()" />
  </div>
</template>

<script>
import moment from 'moment/moment'

export default {
  name: 'Waitingcall',
  props: [
    'ln',
    'locale',
    'isPublic',
    'translateType'
  ],
  computed: {
    spaceCode () {
      const authInfo = this.$store.getters['authentication/getAuthInfo']
      return authInfo && authInfo.spaceCode
    },
    spaceCodeName () {
      const info = this.info && this.info.info
      const spaceCodeName = info && info.name[this.ln]
      return spaceCodeName || null
    }
  },
  watch: {
    async '$route' (to) {
      const skipStatusCheck = [
        'waitingcallStatus',
        'waitingcallResult',
        'waitingcallInvalid'
      ].includes(to.name)

      if (!skipStatusCheck && this.getRid()) {
        const redirected = await this.checkRid()
        if (redirected) return
      }

      this.checkActivate()
      this.checkQuickEntry()
      this.checkAvailableTime(to.name)
    }
  },
  created () {
    this.init()
  },
  data () {
    return {
      info: null,
      availableTime: {
        startTime: '0000',
        endTime: '2359'
      },
      activate: true,
      quickEntryPage: null // 등록시간 중 특정 페이지로 넘어가야 할 때
    }
  },
  methods: {
    getResultData (code) {
      return this.$store.getters['waitingcall/getWaitingcallResultData'](code)
    },
    getRid () {
      const params = new URLSearchParams(window.location.search)
      return params.get('rid')
    },
    async checkRidAuth () {
      const rid = this.getRid()

      if (!rid) return true

      const auth = await this.$store.dispatch(
        'waitingcall/authWaiting',
        {
          spaceCode: this.spaceCode,
          authType: 'rid',
          authData: rid
        }
      )

      return auth && auth.status === 200
    },
    async checkWaitingcallStatus () {
      const rid = this.getRid()

      if (!rid) return false

      const getStatus = await this.$store.dispatch(
        'waitingcall/getWaitingcallStatus',
        {
          spaceCode: this.spaceCode,
          rid
        }
      )

      // 정상적으로 등록정보 조회됨
      const statusRid =
        getStatus &&
        getStatus.status === 200 &&
        getStatus.data &&
        getStatus.data.message &&
        getStatus.data.message.currentStatus !== "CANCEL" &&
        getStatus.data.message.rid

      if (statusRid) {
        if (this.$route.name !== 'waitingcallStatus') {
          await this.$router.replace({
            name: 'waitingcallStatus',
            params: {
              ln: this.ln,
              rid: statusRid
            }
          })
        }

        return true
      }

      // 다른 spaceCode에 등록되어 있음
      const statusResult = getStatus && getStatus.message
      const statusCode = statusResult && statusResult.code
      const statusSpaceCode =
        statusResult &&
        statusResult.reason &&
        statusResult.reason.spaceCode

      if (statusCode !== 305 || !statusSpaceCode) {
        return false
      }

      const location = window.location
      const searchParams = new URLSearchParams(location.search)

      searchParams.set('spaceCode', statusSpaceCode)

      window.history.replaceState(
        {},
        null,
        `${location.origin}${location.pathname}?${searchParams.toString()}${location.hash}`
      )

      await this.$store.dispatch(
        'authentication/setAuthInfo',
        Object.fromEntries(searchParams)
      )

      if (this.$route.name !== 'waitingcallStatus') {
        await this.$router.replace({
          name: 'waitingcallStatus',
          params: {
            ln: this.ln,
            rid
          }
        })
      }

      return true
    },
    async checkRid () {
      /**
       * rid가 있으면 auth (authType: rid)
       * 유효하면 status 검사 후 기존로직 그대로
       * rid가 있는데 유효하지 않으면 이용할 수 없는 상태로
       * 별도의 router 이동(웨이팅콜을 이용할 수 없음)
       */
      const rid = this.getRid()

      if (!rid) return false

      const isValid = await this.checkRidAuth()
      if (!isValid) {
        await this.$router.replace({
          name: 'waitingcallInvalid'
        })
        return true
      }

      return this.checkWaitingcallStatus()
    },
    async init () {
      const redirected = await this.checkRid()
      const spaceCode = this.spaceCode

      if (spaceCode) {
        const infoData = await this.$store.dispatch('waitingcall/getWaitingcallData')

        if (infoData) {
          this.info = infoData[spaceCode]
        }

        if (redirected) return

        const spaceCodeData = await this.$store.dispatch('waitingcall/getSpaceCodeSetting', spaceCode)
        const settingData = spaceCodeData && spaceCodeData.data && spaceCodeData.data.message
        const setting = settingData && settingData.settings
        this.activate = settingData && settingData.use
        if (spaceCodeData && settingData) {
          this.checkActivate()
          if (setting && setting.quickEntry) {
            this.quickEntryPage = setting.quickEntry.active
              ? setting.quickEntry.quickEntryPage
              : null
            this.checkQuickEntry()
          }
          if (setting && setting.availableTime) {
            this.availableTime = setting.availableTime
          }
          this.checkAvailableTime(this.$route.name)
        } else {
          const errorCode = spaceCodeData && spaceCodeData.message && spaceCodeData.message.code || 500
          const errorMessage = this.getResultData(errorCode)
          const reason = spaceCodeData && spaceCodeData.message && spaceCodeData.message.reason
          alert(this.locale[`alert_waitingcall_${errorMessage}`] + (reason ? `\n${reason}` : ''))
          this.$store.commit('loading', false)
        }
      } else {
        // alert(`missing spaceCode:\n${this.locale.access_correct_path}`)
        this.$router.replace({
          name: 'waitingcallInvalid'
        })
      }
    },
    checkActivate () {
      if (!this.activate) {
        this.$router.replace({
          name: 'waitingcallDisabled'
        })
      }
    },
    checkAvailableTime (routerName) {
      const startTime = numToHhmm(this.availableTime.startTime)
      const endTime = numToHhmm(this.availableTime.endTime)
      const isValidStart = moment().isSameOrAfter(moment().set({hour: startTime.hh, minute: startTime.mm, second: 0}))
      const isValidEnd = moment().isSameOrBefore(moment().set({hour: endTime.hh, minute: endTime.mm, second: 0}))
      const isAvailable = isValidStart && isValidEnd
      const isActivate = this.activate
      function numToHhmm (num) {
        return {
          hh: num.slice(0, 2),
          mm: num.slice(2, 4)
        }
      }
      if (routerName === 'waitingcallAuth' || routerName === 'waitingcallApply') { // 등록하려 할 때
        if (!isAvailable || !isActivate) { // 이용불가능한 시간 || 비활성화
          this.$router.replace({
            name: 'waitingcallDisabled'
          })
        } else {
          // this.checkQuickEntry()
        }
      } else if (routerName === 'waitingcallDisabled') { // disabled 페이지에서
        if (isAvailable && isActivate) { // 이용가능한 시간 && 활성화
          this.$router.replace({
            name: 'waitingcallAuth',
            params: {
              ln: this.ln,
              nationality: 'domestic'
            }
          })
        }
      }
    },
    async checkQuickEntry () {
      if (this.quickEntryPage) {
        const isValidPage = await this.$store.dispatch('page/loadPage', this.quickEntryPage, true)
        if (isValidPage && isValidPage.id === this.quickEntryPage) {
          this.$router.replace({
            name: 'page',
            params: {
              ln: this.ln,
              id: this.quickEntryPage
            }
          })
        }
      }
    }
  }
}
</script>
